import * as React from 'react';
import { useGroundingMenuError_unstable } from './useGroundingMenuError';
import { renderGroundingMenuError_unstable } from './renderGroundingMenuError';
import { useGroundingMenuErrorStyles_unstable } from './useGroundingMenuErrorStyles.styles';
import type { GroundingMenuErrorProps } from './GroundingMenuError.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

// GroundingMenuError component - TODO: add more docs
export const GroundingMenuError: ForwardRefComponent<GroundingMenuErrorProps> = React.forwardRef((props, ref) => {
  const state = useGroundingMenuError_unstable(props, ref);

  useGroundingMenuErrorStyles_unstable(state);
  return renderGroundingMenuError_unstable(state);
});

GroundingMenuError.displayName = 'GroundingMenuError';
